export default __webpack_public_path__ + "static/Entenda0104-12beefcffc7c1a7ae23bc4f805647a26.jpg";